import React from "react";
import KC_Heading1 from "../../../designsystem/typography/KC-Heading/KC_Heading1";
import KC_Text from "../../../designsystem/typography/KC_Text/KC_Text";
import { tt } from "../../../utils/i18n/i18n";

export default function AnalyticsPlaceholder() {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <div className="d-flex justify-content-center flex-column align-items-center">
        <KC_Heading1 text={tt("analytics_no_players_yet")} />
        <KC_Text
          size={"lg"}
          weight={"reg"}
          text={tt("analytics_use_communication_kit")}
        />
      </div>
    </div>
  );
}
